import React from "react";
import { Spinner } from "react-bootstrap";
import EmptyFeedCard from "../../../../../_uiComponents/EmptyFeedCard";

export default ({
  assessmentKits,
  assesmentKitsLoading,
  onEditKitClick,
  onViewAssessmentsClick,
  onViewCandidatesClick,
  
}) => {
  return (
    <div className="dashboard-component-container mt-4 border border-6 p-3 bg-white dashboard-custom-tabs dashboard-assessment-kit-list-wrapper h-100">
      <div className="d-flex align-items-center justify-content-between">
        <h4>Assessment Kits</h4>
        <button
          onClick={onViewAssessmentsClick}
          className="bg-transparent border-0 fs-14 text-primary font-weight-medium"
        >
          View All
        </button>
      </div>
      <ul className="dashboard-assessment-kit-list">
        {assesmentKitsLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            {Array.isArray(assessmentKits) && assessmentKits.length ? (
              <>
                {Array.isArray(assessmentKits) &&
                  assessmentKits.map((item) => (
                    <li className="d-flex flex-column p-4 bg-white border position-relative h-100 border-radius-10 mb-2">
                      <div className="upper">
                        <div className="d-flex justify-content-between">
                          <div className="job-info">
                            <h3 className="text-dark mb-1 text-capitalize ">
                              {item?.title}
                            </h3>
                          </div>

                          <div className="d-flex align-items-center">
                            <button
                              className="bg-transparent border-0 text-dark"
                              title="Edit"
                              onClick={() => onEditKitClick(item?.id)}
                            >
                              <img
                                src="/assets/images/edit-grey.svg"
                                alt="edit"
                              />
                            </button>

                          </div>
                        </div>

                        <div className="mb-2 d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center fs-smallest  justify-content-between">
                            <p className="text-grey-4 mb-0">
                              {Array.isArray(item?.skills) && (
                                <span className="border rounded-lg p-1 mr-2 d-inline-block">
                                  Skills{" "}
                                  <span className="font-weight-medium text-dark bg-grey rounded-lg py-1 px-2">
                                    {item?.skills &&
                                      item?.skills.length}
                                  </span>{" "}
                                </span>
                              )}
                              <span className="border rounded-lg p-1 d-inline-block">
                                Questions{" "}
                                <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                                  {item?.total_questions}
                                </span>{" "}
                              </span>
                            </p>
                          </div>

                          <button
                            onClick={() =>
                              onViewCandidatesClick(item?.id)
                            }
                            className="border-0 bg-transparent text-primary py-0 mr-2 cursor-pointer text-nowrap font-weight-medium fs-smallest"
                          >
                            View Candidates
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
              </>
            ) : (
              <EmptyFeedCard
                src="/assets/images/assessment-empty-state.svg"
                message={"No Assessment Kits"}
                description={
                  "Start guiding candidates through their journey by assigning, and evaluating their assessment kits."
                }
                btnText={"Create Assessment Kit"}
                link={"/create-assessment"}
              />
            )}
          </>
        )}
      </ul>
    </div >
  );
};
